'use client';

import CapsuleButton, { TrackedButton } from '@/components/button';
import Spinner from '@/components/spinner';
import downloadIcon from '@images/download.svg';
import { cn } from '@lib/utils';
import Image from 'next/image';
import { ButtonHTMLAttributes } from 'react';
import { useDownload } from '../_hooks';
import { TableDataType } from '../_types';

interface DownloadButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  title: string;
  data: TableDataType[];
}

const buttonBaseStyle =
  'flex w-fit gap-2 pl-[32px] pr-[40px] py-[12px] max-[500px]:pl-5 max-[500px]:pr-7 max-[500px]:py-2.5 text-sm xl:text-base font-semibold leading-6 tracking-[-0.18px] disabled:cursor-not-allowed disabled:pointer-events-auto';

function DownloadButton({
  className,
  title,
  data,
  disabled,
  ...rest
}: DownloadButtonProps) {
  const { isDownloadLoading, handleDownload } = useDownload(data);

  const isDisabled = isDownloadLoading || disabled || data.length === 0;

  return (
    <CapsuleButton
      variant="primary"
      size="large"
      className={cn(buttonBaseStyle, className)}
      asChild
    >
      <TrackedButton
        label="export_detail_xls"
        position="main_content"
        disabled={isDisabled}
        onClick={handleDownload}
        {...rest}
      >
        <div className="flex size-6 items-center justify-center">
          {isDownloadLoading ? (
            <Spinner className="size-6" />
          ) : (
            <Image src={downloadIcon} alt="download" width={48} height={48} />
          )}
        </div>
        {title}
      </TrackedButton>
    </CapsuleButton>
  );
}

export default DownloadButton;
